import { ReclamationView } from "src/api/generated/erp/db/types/tables/reclamationView.ts";
import { useRefreshRef } from "src/utils/useRefreshRef.ts";
import { ReclamationsView } from "./ReclamationsView.tsx";
import i18n from "i18next";
import { useState } from "react";
import { ReclamationsDataGridBase } from "./ReclamationsDataGridBase.tsx";
import { OpenReclamationsDataGrid } from "src/components/views/erp/reclamation/OpenReclamationsDataGrid.tsx";

export const AllReclamationsPage = () => {
	const openReclamationsRefreshRef = useRefreshRef();
	const closedReclamationsRefreshRef = useRefreshRef();
	const taskViewRefreshRef = useRefreshRef();

	const [selectedOpenReclamations, setSelectedOpenReclamations] = useState<ReclamationView[]>([]);
	const [selectedClosedReclamations, setSelectedClosedReclamations] = useState<ReclamationView[]>(
		[],
	);

	return (
		<ReclamationsView
			selectedReclamations={selectedOpenReclamations.concat(selectedClosedReclamations)}
			taskViewRefreshRef={taskViewRefreshRef}
			upperContent={{
				type: "tab",
				items: [
					{
						type: "panel",
						title: i18n.t("incomplete"),
						content: (
							<OpenReclamationsDataGrid
								refreshRef={openReclamationsRefreshRef}
								selectedReclamations={selectedOpenReclamations}
								onReclamationReleased={() => {
									taskViewRefreshRef.current?.refresh();
								}}
								onReclamationClosed={() =>
									closedReclamationsRefreshRef.current?.refresh()
								}
								onSelectionChanged={(newValue) => {
									setSelectedOpenReclamations(newValue);
									setSelectedClosedReclamations([]);
								}}
							/>
						),
					},
					{
						type: "panel",
						title: i18n.t("closed"),
						content: (
							<ReclamationsDataGridBase
								states={["CLOSED"]}
								refreshRef={closedReclamationsRefreshRef}
								onReclamationCloseReverted={() =>
									openReclamationsRefreshRef.current?.refresh()
								}
								selectedReclamations={selectedClosedReclamations}
								onSelectionChanged={(newValue) => {
									setSelectedClosedReclamations(newValue);
									setSelectedOpenReclamations([]);
								}}
							/>
						),
					},
				],
			}}
		/>
	);
};
